import { render, staticRenderFns } from "./statsCard.vue?vue&type=template&id=d454e5e0&scoped=true&"
import script from "./statsCard.vue?vue&type=script&lang=js&"
export * from "./statsCard.vue?vue&type=script&lang=js&"
import style0 from "./statsCard.vue?vue&type=style&index=0&id=d454e5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d454e5e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d454e5e0')) {
      api.createRecord('d454e5e0', component.options)
    } else {
      api.reload('d454e5e0', component.options)
    }
    module.hot.accept("./statsCard.vue?vue&type=template&id=d454e5e0&scoped=true&", function () {
      api.rerender('d454e5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/statsCard.vue"
export default component.exports